import { render } from "./exportIcon.vue?vue&type=template&id=67a28c1f"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/icons/exportIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "67a28c1f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('67a28c1f', __exports__)) {
    api.reload('67a28c1f', __exports__)
  }
  
  module.hot.accept("./exportIcon.vue?vue&type=template&id=67a28c1f", () => {
    api.rerender('67a28c1f', render)
  })

}


export default __exports__